// Minimal runtime module to satisfy imports for types
import type {ChatDataType} from '@/types/apps/chatTypes'
import type {Store, Dispatch, UnknownAction} from 'redux'

export type RootState = {
    chatReducer: ChatDataType
    [key: string]: unknown
}

export type AppDispatch = Dispatch<UnknownAction>

// Provide a minimal runtime-compatible store object so <Provider store={store}> works
// This avoids errors like "store.getState is not a function" during Next.js/Turbopack runtime
const defaultState: RootState = {
    chatReducer: {
        contacts: [],
        chats: [],
        profileUser: undefined,
        activeUser: undefined
    }
}

function createMinimalStore(initialState: RootState): Store<RootState, UnknownAction> {
    const state = initialState
    const listeners: Array<() => void> = []

    return {
        getState() {
            return state
        },
        dispatch(action: UnknownAction) {
            // no-op dispatch for runtime fallback; return action for compatibility
            return action
        },
        subscribe(listener: () => void) {
            listeners.push(listener)
            return () => {
                const idx = listeners.indexOf(listener)
                if (idx >= 0) listeners.splice(idx, 1)
            }
        },
        replaceReducer() {
            // noop
        }
    } as unknown as Store<RootState, UnknownAction>
}

export const store = createMinimalStore(defaultState)
